import classNames from "classnames";
import "./styles.sass";

type LoyaltyFormulaExperienceProps = {
  currency: string;
  amount: number;
  experience: number;
  className?: string;
};

const LoyaltyFormulaExperience = (props: LoyaltyFormulaExperienceProps) => {
  const { currency, amount, experience, className } = props;

  const classFormula = classNames("LoyaltyFormulaExperience", className);

  return (
    <span className={classFormula}>
      {experience.toFixed(0)} XP = {amount.toFixed(1)} {currency}
    </span>
  );
};

export default LoyaltyFormulaExperience;
